<template>
  <div class="disturber d-flex align-items-center" v-if="!hasCookie">
    <div class="container d-none d-lg-block">
      <div class="row d-flex justify-content-around desktop">
        <!-- Desktop und Tablet -->
        <div class="col-md-6">
          <!-- Bild 1 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_1_desktop.filename"
                class="card-img"
                :alt="storyblokData.background_1_desktop.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text  text-center">{{ storyblokData.text_1_desktop }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_1_classes" @click="navigateToTarget(1)">
                {{ storyblokData.btn_1_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <p></p>
        </div>

        <div class="col-md-6">
          <!-- Bild 2 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_2_desktop.filename"
                class="card-img"
                :alt="storyblokData.background_2_desktop.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text text-center">{{ storyblokData.text_2_desktop }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_2_classes" @click="navigateToTarget(2)">
                {{ storyblokData.btn_2_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container d-none d-md-block d-lg-none">
      <div class="row d-flex justify-content-around tablet">
        <!-- Desktop und Tablet -->
        <div class="col-8">
          <!-- Bild 1 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_1_mobile.filename"
                class="card-img"
                :alt="storyblokData.background_1_mobile.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text  text-center">{{ storyblokData.text_1_mobile }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_1_classes" @click="navigateToTarget(1)">
                {{ storyblokData.btn_1_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <p></p>
        </div>

        <div class="col-8">
          <!-- Bild 2 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_2_mobile.filename"
                class="card-img"
                :alt="storyblokData.background_2_mobile.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text text-center">{{ storyblokData.text_2_mobile }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_2_classes" @click="navigateToTarget(2)">
                {{ storyblokData.btn_2_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container d-block d-md-none">
      <div class="row d-flex justify-content-around mobile">
        <!-- Desktop und Tablet -->
        <div class="col-10">
          <!-- Bild 1 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_1_mobile.filename"
                class="card-img"
                :alt="storyblokData.background_1_mobile.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text  text-center">{{ storyblokData.text_1_mobile }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_1_classes" @click="navigateToTarget(1)">
                {{ storyblokData.btn_1_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <p></p>
        </div>

        <div class="col-10">
          <!-- Bild 2 -->
          <div class="card bg-dark text-white">
            <img
                :src="storyblokData.background_2_mobile.filename"
                class="card-img"
                :alt="storyblokData.background_2_mobile.alt"
            >
            <div class="card-img-overlay d-flex flex-column justify-content-end">
              <p class="card-text text-center">{{ storyblokData.text_2_mobile }}</p>
              <button type="button" class="btn btn-primary btn-lg" :class="storyblokData.btn_2_classes" @click="navigateToTarget(2)">
                {{ storyblokData.btn_2_text }}&nbsp;&nbsp;&nbsp;
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Disturber",
  props: {
    storyblokData: {
      type: Object,
      required: true
    },
    system: {
      type: String,
      required: true
    }
  },

  methods: {
    navigateToTarget(option) {
      this.$cookies.set(this.storyblokData.cookiename, 1, 60 * 60 * 24 * 90) // ca 3 Monate Lifetime
      if(this.system === "production") {
        window.location.replace(this.storyblokData['link_' + option]);
      }
      else {
        window.location.replace(window.location.href);
      }
    }
  },

  computed: {
    hasCookie() {
      return this.$cookies.isKey(this.storyblokData.cookiename);
    }
  }
}
</script>

<style scoped lang="scss">

$border-radius: 10px;
$border: 5px solid white;

.disturber {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.8);
  z-index: 2;

  * {
    z-index: 3;
  }


  .desktop {
    .card {
      border: $border;
      border-radius: $border-radius;

      p {
        font-size: 2.5rem;
        font-weight: 900;
      }

      button {
        width: 70%;
        align-self: center;
        font-size: 1.5rem;
        font-weight: 900;
        padding-bottom: 1.5rem;
        padding-top: 1.5rem;
      }
    }
  }

  .tablet {
    .card {
      border: $border;
      border-radius: $border-radius;

      p {
        font-size: 2.5rem;
        font-weight: 900;
      }

      button {
        width: 70%;
        align-self: center;
        font-size: 1.5rem;
        font-weight: 900;
        padding-bottom: 1.5rem;
        padding-top: 1.5rem;
      }
    }
  }

  .mobile {
    .card {
      border: $border;
      border-radius: $border-radius;

      p {
        font-size: 1.5rem;
        font-weight: 900;
      }

      button {
        width: 80%;
        align-self: center;
        font-size: 1.0rem;
        font-weight: 900;
        padding-bottom: 1.0rem;
        padding-top: 1.0rem;
      }
    }
  }
}
</style>
